<template>
      <div class="add-wrap">
<!--        <p class="add-label">新增地址</p>-->
        <div class="form-row">
          <span class="form-label">收货人</span>
          <div class="form-input-box">
            <el-input v-model="params.name" placeholder="请输入姓名"></el-input>
          </div>
        </div>
        <div class="form-row">
          <span class="form-label">手机号</span>
          <div class="form-input-box">
            <el-input v-model="params.mobile" placeholder="请输入手机号"></el-input>
          </div>
        </div>
        <div class="form-row">
          <span class="form-label">收货地址</span>
          <div class="form-select-box">
            <div class="select-box">
              <el-select
                  placeholder="请选择省份"
                  v-model="params.province_id"
                  @change="selectAddress(0)"
              >
                <el-option
                    v-for="(item, index) in provinceList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="select-box">
              <el-select
                  placeholder="请选择县区"
                  v-model="params.city_id"
                  @change="selectAddress(1)"
              >
                <el-option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="select-box">
              <el-select
                  placeholder="请选择街/道"
                  v-model="params.district_id"
                  @change="selectAddress(2)"
              >
                <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-row-column">
          <span class="form-label">详细位置</span>
          <div class="form-textarea-box">
            <el-input type="textarea" placeholder="请输入详细位置" v-model="params.address" maxlength="80"
                      show-word-limit>
            </el-input>
          </div>
        </div>
        <div class="default-row" @click="params.is_default = params.is_default === 1 ? 0 : 1">
          <img v-if="params.is_default === 1" src="../assets/square-active.png">
          <img v-else src="../assets/square.png">
          设为默认地址
        </div>
        <div class="btn-box">
          <button type="button" @click="submit()">保存</button>
        </div>
      </div>

</template>

<script>

import {AddressService, MemberaddressService} from "@/common/service";
import {validatorFun} from "@/common/util";
import {Message} from "element-ui";

export default {
  name: 'address-save',
  props: {
    show: {
      default: true,
    },
    addressData: {
      default: null,
    },
  },
  data() {
    const params = {
      id: 0,
      name: '', // 套餐名称
      mobile: '', // 手机号码
      province_id: '', // 省id
      city_id: '', // 市id
      district_id: '', // 县区
      address: '', // 地址
      full_address: '', // 市名称+区县名称+地址
      is_default: 0, // 是否是默认地址 1是 0否
    };
    const validatorNullList = [
      ['name', ['notNull', '请输入姓名']],
      ['mobile', ['notNull', '请输入手机号']],
      ['province_id', ['notNull', '请选择省份']],
      ['city_id', ['notNull', '请选择城市']],
      ['district_id', ['notNull', '请选择区县']],
      ['address', ['notNull', '请输入详细地址']],
    ];
    const validatorNullResult = validatorFun(params, validatorNullList);
    return {
      params,
      validatorNullList,
      validatorNullResult,
      provinceList: [],
      provinceMap: {},
      cityList: [],
      cityMap: {},
      areaList: [],
      areaMap: {},
    };
  },
  mounted() {
    this.params = JSON.parse(JSON.stringify(this.addressData || {
      province_id: '', // 省id
      city_id: '', // 市id
      district_id: '', // 县区
      ...this.params,
    }));
    this.getAddressTree();
  },
  watch: {
    addressData(val) {
      this.params = {
        id: 0,
        name: '', // 套餐名称
        mobile: '', // 手机号码
        province_id: '', // 省id
        city_id: '', // 市id
        district_id: '', // 县区
        address: '', // 地址
        full_address: '', // 市名称+区县名称+地址
        is_default: 0, // 是否是默认地址 1是 0否
        ...(JSON.parse(JSON.stringify(val || {})))
      };
      if (this.params.id > 0) {
        this.getAddressTree(0);
            // .then(() => this.getAddressTree(1))
            // .then(() => this.getAddressTree(2));
      }
    },
    params: {
      deep: true,
      handler (obj) {
        this.validatorNullResult = validatorFun(obj, this.validatorNullList);
      },
    }
  },
  methods: {
    submit() {
      const params = this.params;
      if (this.validatorNullResult.length > 0) {
        return Message.warning(this.validatorNullResult[0].errMsg);
      }
      params.full_address
          = this.provinceMap[params.province_id].name
          + this.cityMap[params.city_id].name
          + this.areaMap[params.district_id].name
          + params.address;
      const api = params.id > 0 ? MemberaddressService.edit : MemberaddressService.add;
      api(params).then(() => {
        Message.success(params.id > 0 ? '更新成功' : '新增成功');
        this.$emit('submitSuccess', params);
      }).catch(() => {
        this.$emit('submitError', params);
      });
    },
    selectAddress(level) {
      if (level < 2) {
        if (level === 0) {
          this.cityList = [];
          this.areaList = [];
          this.params.city_id = '';
          this.params.district_id = '';
        }
        if (level === 1) {
          this.areaList = [];
          this.params.district_id = '';
        }
        this.getAddressTree(level + 1);
      }
    },
    getAddressTree(level = 0) {
      const levelKeyMap = {
        0: 'province',
        1: 'city',
        2: 'area',
      };
      const levelIdMap = {
        0: 0,
        1: this.params.province_id,
        2: this.params.city_id,
      };
      const key = levelKeyMap[level];
      const id = levelIdMap[level];

      return AddressService.tree({id}).then(({data}) => {
        this.$set(this, `${key}List`, data);
        this.$set(this, `${key}Map`, data.reduce((obj, item) => ({
          ...obj,
          [item.id]: item,
        }), {}));
      });
    },
  },
}
</script>

<style scoped>

.btn-box {
  width: 100%;
  display: flex;
  align-items: center;
}

.btn-box>button {
  width: 112px;
  height: 33px;
  line-height: 33px;
  background-color: #FF6619;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  box-sizing: border-box;
}

.btn-box>button:last-child {
  margin-right: 0;
}

.btn-box>button.border-btn {
  border: 1px solid #666666;
  color: #666666;
  background-color: #EEEEEE;
}

.add-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  /*padding: 20px 30px;*/
  box-sizing: border-box;
  background-color: #FFFFFF;
  border-radius: 8px;
}

.add-label {
  width: 100%;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;
}


.form-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 17px;
}

.form-row-column {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.form-label {
  width: 71px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 5px;
  box-sizing: border-box;
}

.form-input-box {
  width: 131px;
  display: flex;
  align-items: center;
}

.form-select-box {
  width: 401px;
  display: flex;
  align-items: center;
}

>>>.el-input__inner {
  border-radius: 8px !important;
  border: 1px solid #666666 !important;
  color: #606266 !important;
  height: 30px !important;
  line-height: 30px !important;
}

>>>.el-input__inner::placeholder {
  color: #999999 !important;
}

>>>.el-input__icon {
  line-height: 30px !important;
}

>>>.el-select .el-input .el-select__caret {
  color: #666666 !important;
}

.select-box {
  flex: 1;
  margin-right: 14px;
}

.select-box:last-child {
  margin-right: 0;
}

.form-textarea-box {
  width: 576px;
  margin-top: 11px;
}

>>>.el-textarea__inner {
  color: #606266;
  border-radius: 8px !important;
  border: 1px solid #666666 !important;
  color: #606266 !important;
  padding: 7px 13px !important;
  box-sizing: border-box;
}

>>>.el-textarea__inner::placeholder {
  color: #999999 !important;
}

.default-row {
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 12px;
  margin: 11px 0 39px;
}

.default-row>img {
  width: 13px;
  margin-right: 6px;
}


</style>
